import React, { useState } from 'react';
import "./NewNavbar.css";

const academics = [
  {
    name: "Faculty of Civil and Mechanical Engineering (FoC&M)",
    departments: [
      { id: 31, name: "Civil Engineering" },
      { id: 32, name: "Mechanical Engineering" },
      { id: 33, name: "Building & Architectural" },
      { id: 34, name: "Industrial & Manufacturing" },
    ],
  },
  {
    name: "Faculty of Electrical and Electronic Engineering (FoEEE)",
    departments: [
      { id: 35, name: "Electrical Engineering" },
      { id: 37, name: "Electronic Engineering" },
      { id: 38, name: "Telecommunication Eng." },
      { id: 40, name: "Electrical (Automation and Control)" },
      { id: 41, name: "Biomedical" },
    ],
  },
  {
    name: "Faculty of Computer Engineering (FoCE)",
    departments: [
      { id: 36, name: "Computer Systems" },
      { id: 39, name: "Software Engineering" },
      { id: 44, name: "Artificial Intelligence" },
    ],
  },
  {
    name: "Faculty of Science (FoS)",
    departments: [
      { id: 42, name: "Information Technology" },
      { id: 43, name: "Computer Science" },
      { id: 45, name: "Cyber Security" },
      { id: 46, name: "Data Science" },
      { id: 47, name: "English" },
      { id: 48, name: "Mathematics & Statistics" },
      { id: 49, name: "Physics" },
      { id: 50, name: "Chemistry" },
    ],
  },
  {
    name: "Faculty of Environmental Engineering (FoEE)",
    departments: [
      { id: 51, name: "Chemical Engineering" },
      { id: 52, name: "Environmental Engineering" },
    ],
  },
  {
    name: "Faculty of Technology (FoT)",
    departments: [
      { id: 28, name: "Electrical Technology" },
      { id: 29, name: "Mechanical Technology" },
      { id: 30, name: "Basics Sciences and Related Studies" },
    ],
  },
];

const hostels = [
  {
    name: "Hostels and Accommodations",
    departments: [
      { name: "Office of the Provohost", link: "/OP" },
      { name: "In-campus Hostels and Accommodations", link: "/ICH" },
      { name: "Fee Structure", link: "/FST" },
      { name: "Accommodations for International Students", link: "/AIS" },
    ],
  },
  {
    name: "In-campus Hostels, and Blocks",
    departments: [
      { name: "Blocks List", link: "/BL" },
      { name: "Block-wise Wardens List", link: "/BWL" },
    ],
  },
];

const administration = [
  {
    name: "Vice Chancellor Office",
    link: "/administration/vc-office",
  },
  {
    name: "Registrar Office",
    link: "/administration/registrar-office",
  },
  {
    name: "Finance Department",
    link: "/administration/finance",
  },
  {
    name: "IT Department",
    link: "/administration/it",
  },
];

function NewNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleMouseEnter = (menu) => setActiveMenu(menu);
  const handleMouseLeave = () => setActiveMenu(null);

  return (
    <header className="navbar">
      <div className="navbar-container">
        <div className="logo-container">
          <a href="/" className="brand">
            <img src="/images/mono1.png" alt="University Logo" className="logo" />
            <span>QUEST&nbsp;|&nbsp;Nawabshah</span>
          </a>
          <button className="hamburger" onClick={toggleMenu} aria-label="Toggle navigation">
            {menuOpen ? '✖' : '☰'}
          </button>
        </div>

        <nav className={`nav-menu ${menuOpen ? 'open' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item"><a href="/home" className="nav-link">Home</a></li>
            <li
              className="nav-item dropdown"
              onMouseEnter={() => handleMouseEnter('academics')}
              onMouseLeave={handleMouseLeave}
            >
              <div className="dropdown-toggle">Academics</div>
              {activeMenu === 'academics' && (
                <ul className="dropdown-menu multi-column">
                  {academics.map((faculty, index) => (
                    <li key={index} className="dropdown-column">
                      <h4>{faculty.name}</h4>
                      <ul className="dropdown-submenu">
                        {faculty.departments.map((dept) => (
                          <li key={dept.id} className="submenu-item">
                            <a href={`/department/${dept.id}`} className="dropdown-link">{dept.name}</a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            <li
              className="nav-item dropdown"
              onMouseEnter={() => handleMouseEnter('hostels')}
              onMouseLeave={handleMouseLeave}
            >
              <div className="dropdown-toggle">Hostels</div>
              {activeMenu === 'hostels' && (
                <ul className="dropdown-menu multi-column">
                  {hostels.map((section, index) => (
                    <li key={index} className="dropdown-column">
                      <h4>{section.name}</h4>
                      <ul className="dropdown-submenu">
                        {section.departments.map((dept, deptIndex) => (
                          <li key={deptIndex} className="submenu-item">
                            <a href={dept.link} className="dropdown-link">{dept.name}</a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            <li
              className="nav-item dropdown"
              onMouseEnter={() => handleMouseEnter('administration')}
              onMouseLeave={handleMouseLeave}
            >
              <div className="dropdown-toggle">Administration</div>
              {activeMenu === 'administration' && (
                <ul className="dropdown-menu">
                  {administration.map((item, index) => (
                    <li key={index} className="submenu-item">
                      <a href={item.link} className="dropdown-link">{item.name}</a>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            <li className="nav-item"><a href="/research" className="nav-link">Research</a></li>
            <li className="nav-item"><a href="/admissions" className="nav-link">Admissions</a></li>
            <li className="nav-item"><a href="/scholarships" className="nav-link">Scholarships</a></li>

            <li className="nav-item"><a href="/about" className="nav-link">About</a></li>
            <li className="nav-item"><a href="/facultydirectory" className="nav-link">Faculty Directory</a></li>

            <li className="nav-item"><a href="/login" className="nav-link">Login</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default NewNavbar;
